import React, { Component } from 'react';
import cx from 'classnames';
import { Modal } from 'react-bootstrap';

import styles from './_mobileNoteModal.module.scss';
import './_mobileNoteModalModal.scss';

export default class MobileNoteModal extends Component {
  render() {
    const { isModalVisible, closeModal, onConfirm } = this.props;
    return (
      <div className={cx(styles['mobile-cancel-purchase'])}>
        <Modal show={isModalVisible} size="lg" centered>
          <div className="mobile-cancel-purchase">
            <div className="close-btn" onClick={closeModal}>
              <img src="/images/cross.svg" alt="close" />
            </div>
            <div>
              <div className="cancel-purchase-title">PLEASE NOTE</div>

              <div className="cancel-purchase-rewards">
                <div className="cancel-purchase-not-leaving">
                  You will now be redirected to setup your savings plan.
                </div>
                You will be redirected to your bank page. Please follow the instructions there to
                complete the setup.
              </div>
              <div className="cancel-purchase-btns">
                <button onClick={onConfirm}>CONFIRM</button>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
